/**
 * Schémas Zod CRM — tâches et rappels (E08-08).
 */
import { z } from 'zod';
import { CRM_REMINDER_CHANNELS, CRM_TASK_PRIORITIES, CRM_TASK_STATUSES, } from '../enums/crm.enum.js';
import { paginationQuerySchema, uuidSchema } from './common.schema.js';
const optionalText = (max) => z.string().trim().max(max).nullable().optional();
const isoDateTimeSchema = z.string().datetime().nullable().optional();
/** Rappel planifié rattaché à une tâche. */
export const taskReminderSchema = z.object({
    remindAt: z.string().datetime(),
    channel: z.enum(CRM_REMINDER_CHANNELS).optional(),
});
const taskBaseSchema = {
    title: z.string().trim().min(1).max(180),
    description: optionalText(5000),
    dueAt: isoDateTimeSchema,
    priority: z.enum(CRM_TASK_PRIORITIES).optional(),
    status: z.enum(CRM_TASK_STATUSES).optional(),
    assigneeUserId: uuidSchema.nullable().optional(),
    prospectId: uuidSchema.nullable().optional(),
    clientId: uuidSchema.nullable().optional(),
    opportunityId: uuidSchema.nullable().optional(),
    reminders: z.array(taskReminderSchema).max(20).optional(),
};
/** Paramètres de `GET /tasks`. */
export const taskListQuerySchema = paginationQuerySchema.extend({
    filter: z
        .object({
        status: z.enum(CRM_TASK_STATUSES).optional(),
        priority: z.enum(CRM_TASK_PRIORITIES).optional(),
        assigneeUserId: uuidSchema.optional(),
        prospectId: uuidSchema.optional(),
        clientId: uuidSchema.optional(),
        opportunityId: uuidSchema.optional(),
        dueBefore: z.string().datetime().optional(),
    })
        .optional(),
});
/** Corps de `POST /tasks`. */
export const taskCreateSchema = z.object(taskBaseSchema);
/** Corps de `PATCH /tasks/:id`. */
export const taskUpdateSchema = z
    .object(taskBaseSchema)
    .partial()
    .refine((value) => Object.values(value).some((field) => field !== undefined), {
    message: 'Aucun champ à mettre à jour.',
});
/** Corps de `PATCH /tasks/:id/status`. */
export const taskStatusUpdateSchema = z.object({
    status: z.enum(CRM_TASK_STATUSES),
});
//# sourceMappingURL=task.schema.js.map